import { has } from "../../../../../utils/menu-context";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (has({ menuContext, key: "canEdit" })) {
                result = true || result;
            }
            return result;
        }
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return [
                    "refCompanyType",
                    "companyNameTh",
                    "companyNameEn",
                    "fullNameTh",
                    "fullNameEn",
                    "refDepartmentRegister",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                let result = false;
                if (["1"].includes(modelRef.refPersonType?.key)) {
                    result = true;
                } else {
                    result = false;
                }
                return result;
            }
        },{
            check: ({ field }) => {
                return [
                    "refTitle",
                    "firstNameTh",
                    "middleNameTh",
                    "lastNameTh",
                    "firstNameEn",
                    "middleNameEn",
                    "lastNameEn",
                    "birthDate",
                    "refDepartment",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                let result = true;
                if (["1"].includes(modelRef.refPersonType?.key)) {
                    result = false;
                } else {
                    result = true
                }
                return result;
            }
        },
    ];
};
